module.exports = __webpack_public_path__ + "7dc768e39fc790f9e7890cb7f9e9f88e.svg";